import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type { Control } from 'react-hook-form';

interface TextInputProps {
    field: {
        handle: string;
        label?: string;
        type: string;
        placeholder?: string;
        maxLength?: number;
        instructions?: string;
    };
    control: Control<Record<string, unknown>>;
}

export default function TextInput({ field, control }: TextInputProps) {
    return (
        <FormField
            control={control}
            name={field.handle}
            render={({ field: formField }) => (
                <FormItem>
                    <FormLabel>{field.label}</FormLabel>
                    <FormControl>
                        <Input
                            {...formField}
                            value={formField.value as string}
                            type={field.type}
                            placeholder={field.placeholder || ''}
                            maxLength={field.maxLength || undefined}
                            className="bg-white"
                        />
                    </FormControl>
                    {field.instructions && (
                        <p className="text-muted-foreground text-sm">{field.instructions}</p>
                    )}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
